const fonts = {
  primary: '"Geist", sans-serif',
  secondary: '"Chivo Mono", monospace',
};
export default fonts;
